//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash'
import { mapMutations, mapState } from 'vuex'

import TwitchPreFlightCheck from 'core/components/twitch-pre-flight-check.vue'
import DebutStreamDetails from './debut-stream-details'

// 2/28/2026 1:00 PM ET
const liveTime = Date.UTC(2026, 1, 28, 18, 0, 0)
// 2/28/2026 4:00 PM ET
const endTime = Date.UTC(2026, 1, 28, 21, 30, 0)

const flavors = [
    {
        id: 'vtubing',
        title: 'Our VTuber reveal stream is today!',
        subtitle: 'Come hang out while we play cozy games!',
    },
]

export default {
    name: 'DebutStreamAnnouncement',

    data() {
        return {
            flavor: _.sample(flavors),
            now: Date.now(),
        }
    },

    computed: {
        isLive() {
            return this.now >= liveTime && this.now < endTime
        },

        isOver() {
            return this.now >= endTime
        },

        title() {
            if (this.isLive) return "We're live with our VTuber reveal stream!"
            return this.flavor.title
        },

        snoozeId() {
            return 'pride2025Announcement'
        },

        lastSnooze() {
            return this.snoozes[this.snoozeId]
        },

        snoozeDuration() {
            return 1000 * 60 * 60 * 24 * 7
        },

        isSnoozed() {
            if (!this.lastSnooze) return false
            return (this.lastSnooze + this.snoozeDuration) > Date.now()
        },

        ...mapState({
            snoozes: state => state.core.announcementSnoozes,
        }),
    },

    methods: {
        handleClick() {
            if (this.isLive) {
                this.goTwitch()
            } else {
                this.showDetails()
            }
        },

        showDetails() {
            this.$gtag.event(`debut-details-${this.flavor.id}`)
            this.$present(DebutStreamDetails, { flavor: this.flavor })
        },

        goTwitch() {
            this.$gtag.event('debut-stream-watch-now')
            this.$present(TwitchPreFlightCheck)
        },

        close() {
            this.snoozeAnnouncement(this.snoozeId)
        },

        ...mapMutations(['snoozeAnnouncement']),
    },

    mounted() {
        this.$listenFor('TICK_MIN', () => {
            this.now = Date.now()
        })
    },
}
